/**
 * Convert a canvas element to a data-URL image string.
 *
 * Useful for print layouts where `<canvas>` elements don't render —
 * snapshot the canvas into an `<img src>` that prints reliably.
 */
export function canvasToImage(
  canvas: HTMLCanvasElement | null,
  type: 'image/png' | 'image/jpeg' = 'image/png',
  quality?: number
): string | null {
  if (!canvas) return null
  if (canvas.width === 0 || canvas.height === 0) return null
  return canvas.toDataURL(type, quality)
}
